import countryToCurrency from "country-to-currency";

// República Dominicana
const DOMINICAN_REPUBLIC: string = "DO";

// En República Dominicana la cuenta bancaria de destino debe estar denominada en USD
export const isUsdOnlyCountry = (country: string): boolean => country === DOMINICAN_REPUBLIC;

// Divisa que se selecciona por defecto para el país de la cuenta bancaria
export const getDefaultBankCurrency = (country: string): string =>
  isUsdOnlyCountry(country) ? "USD" : countryToCurrency[country];
